/* global window */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import constants from '../constants.json' assert { type: 'json' };

const FullHeightContainer = ({ children }) => {
    const [minHeight, setMinHeight] = useState(constants.DEFAULT_MINIMUM_CONTAINER_HEIGHT);
    const containerRef = useRef(null);

    useEffect(() => {
        // Function to calculate the remaining height
        const calculateHeight = () => {
            if (containerRef.current) {
                // Get the distance of the container from the top of the document
                const topOffset = containerRef.current.getBoundingClientRect().top + window.scrollY;
                const remainingHeight = window.innerHeight - topOffset;
                setMinHeight(remainingHeight > 0 ? remainingHeight : 0);
            }
        };
        // Initial calculation
        calculateHeight();
    }, []);

    return (
        <div
            ref={containerRef}
            style={{ minHeight: `${minHeight}px` }}
        >
            {children}
        </div>
    );
};

FullHeightContainer.propTypes = {
    children: PropTypes.node,
};

export default FullHeightContainer;
